import classNames from "classnames";
import React, { CSSProperties } from "react";
import { ReactNode } from "react";
import styles from "./button.module.scss"
import { ProgressActionSpinner } from "../progressActionSpinner/ProgressActionSpinner";

export type Variant = "primary" | "outprimary" | "secondary" | "outsecondary" | "danger" | "commandPanel" | "gray" | "lightGray" |"kizPanel"


interface IButtonProps {
    children: ReactNode
    variant: Variant
    disabled?: boolean
    className?:string
    isLoadingSpinner?: boolean
    isLoadingGlobal?: boolean
    style?: CSSProperties
    onClick?: () => any
    buttonType?: 'button' | 'submit' | 'reset';
    tabIndex?: number
    'data-field-id'?: string 
}

export const Button= React.forwardRef<HTMLButtonElement,IButtonProps>((props,ref) => {

    function getType(v: Variant) {
        switch (v) {
            case "primary": {
                return styles.btnPrimary
            }
            case "outprimary": {
                return styles.btnOutPrimary
            }
            case "secondary": {
                return styles.btnSecondary
            }
            case "outsecondary": {
                return styles.btnOutSecondary
            }
            case "danger": {
                return styles.btnDanger
            }
            case "commandPanel": {
                return styles.commandPanel
            }
            case "gray": {
                return styles.btnGray
            }
            case "lightGray": {
                return styles.btnLightGray
            }
            case "kizPanel": {
                return styles.btnKizPanel
            }
        }
    }
    
    return (
        <>
            <button 
                type={props.buttonType}
                ref={ref}
                tabIndex={props.tabIndex} 
                data-field-id={props["data-field-id"]}
                disabled={props.disabled} 
                className={classNames(getType(props.variant),props.className)} 
                style={props.style} 
                onClick={()=>{props.onClick?.()}}
                onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                        e.currentTarget.blur();
                    }
                }}
            >
                {props.isLoadingSpinner ? <i className={styles.spinner}></i> : null}
                {props.children}
            </button>
            {props.isLoadingGlobal ? <ProgressActionSpinner transparency /> : null}
        </>
    )
})